import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';

import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { QueriesService } from './services/queries.service';
import { SpanishPaginatorIntl } from './services/spanish-paginator-intl';
import { appRoutes } from 'app/app.routes';
import { mockApiServices } from 'app/mock-api';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideFuse } from '@fuse';
import { provideHttpClient } from '@angular/common/http';
import { provideIcons } from 'app/core/icons/icons.provider';
import { provideQuillConfig } from 'ngx-quill';

export const appConfig: ApplicationConfig = {
    providers: [
        QueriesService,
        importProvidersFrom(MatSnackBarModule),
        provideAnimations(),
        provideHttpClient(),
        provideRouter(appRoutes,
            withPreloading(PreloadAllModules),
            withInMemoryScrolling({scrollPositionRestoration: 'enabled'}),
        ),
        provideQuillConfig({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                ]
            }
        }),
        {
            provide : DateAdapter,
            useClass: LuxonDateAdapter,
        },
        {
            provide : MAT_DATE_FORMATS,
            useValue: {
                parse  : {
                    dateInput: 'dd-MM-yyyy',
                },
                display: {
                    dateInput         : 'dd-MM-yyyy',
                    monthYearLabel    : 'MMM yyyy',
                    dateA11yLabel     : 'LL',
                    monthYearA11yLabel: 'MMMM yyyy',
                },
            },
        },
        {
            provide: MatPaginatorIntl,
            useClass: SpanishPaginatorIntl,
        },
        // Fuse
        provideAuth(),
        provideIcons(),
        
        provideFuse({
            mockApi: {
                delay   : 0,
                services: mockApiServices,
            },
            fuse   : {
                layout : 'centered',
                scheme : 'light',
                screens: {
                    sm: '600px',
                    md: '960px',
                    lg: '1280px',
                    xl: '1440px',
                },
                theme  : 'theme-brand',
                themes : [
                    {
                        id  : 'theme-default',
                        name: 'Default',
                    },
                    {
                        id  : 'theme-brand',
                        name: 'Brand',
                    },
                    {
                        id  : 'theme-teal',
                        name: 'Teal',
                    },
                    {
                        id  : 'theme-rose',
                        name: 'Rose',
                    },
                    {
                        id  : 'theme-purple',
                        name: 'Purple',
                    },
                    {
                        id  : 'theme-amber',
                        name: 'Amber',
                    },
                ],
            },
        }),
    ],
};
